module.exports = __webpack_public_path__ + "static/media/Dragalge_gaussian2.d011ffdd.png";